import React from "react";
import Modal from '../../shared/RespModalAdmin.js';
import Button from '../../shared/Button';
import '../../../css/announcement/TextMessageModal.css';
class TextMessageModal extends React.Component {
    render() {
        return (
            <div>
                <Modal hasOpen={this.props.hasOpen} >
                    <div class="textMessageUpper">
                        <small class="textMessageHeading">
                            Text Message Announcement
                    </small>
                    </div>
                    <hr className="texthr" />
                    {this.props.children}
                    <br />
                    <div className="btnContainer">
                        <Button
                            type="button"
                            id="textMessageOk"
                            onClick={this.props.onClick}
                        >OK
                    </Button>
                    </div>
                </Modal>
            </div>
        );
    }
}
export default TextMessageModal;